import {useRouter} from 'next/router';
import {useCallback, useContext} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import useUserActions from '@/src/app/store/user/useUserActions';
import useLoading from '@/src/hooks/useLoading';
import useRoutePaths from '@/src/hooks/useRoutePaths';

import PopupContext from '../../../popup/utils/PopupContext';
import fetchUserAction from '../../../signUp/paymentDetails/utils/fetchUserAction';
import ReuploadStudentIdPopupLayout from '../components/ReuploadStudentIdPopupLayout';
import reuploadStudentId from '../utils/reuploadStudentId';

const ReuploadStudentIdPopup = () => {
  const {closePopup} = useContext(PopupContext);
  const {isLoading, setLoading} = useLoading();
  const {setUserData} = useUserActions();
  const {push} = useRouter();
  const {SIGN_IN_ROUTE} = useRoutePaths();

  const handleCancelClick = useCallback(() => {
    closePopup();
  }, [closePopup]);

  const handleSubmitClick = useCallback(
    async (values, {setFieldError}) => {
      const {status, responseBody} = await reuploadStudentId(values);

      if (status === RESPONSE_STATUSES.SUCCESS) {
        const {status: fetchUserStatus, responseBody} = await fetchUserAction();
        setLoading(false);

        if (fetchUserStatus === RESPONSE_STATUSES.SUCCESS) {
          setUserData(responseBody);
          closePopup();
        } else {
          push(SIGN_IN_ROUTE.getLink());
        }
      }

      if (
        responseBody &&
        responseBody.error &&
        typeof responseBody.error === 'object'
      ) {
        for (const key in responseBody.error) {
          if (Object.prototype.hasOwnProperty.call(responseBody.error, key)) {
            setFieldError(key, responseBody.error[key]);
          }
        }
      }
    },
    [setUserData, closePopup, push]
  );

  return (
    <ReuploadStudentIdPopupLayout
      onCancelClick={handleCancelClick}
      onSubmitClick={handleSubmitClick}
      isLoading={isLoading}
    />
  );
};

export default ReuploadStudentIdPopup;
